"use client";

import Cookies from "js-cookie";
import { useCallback, useState } from "react";
import { useAuthBackendId } from "@/app/providers/AuthBackendModeProvider/AuthBackendContext";
import { getAuthBackend } from "@/lib/authBackend/resolve";
export function useEmsNotEntitledPage() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const authBackendId = useAuthBackendId();
  const handleSignOut = useCallback(async () => {
    setIsLoggingOut(true);
    try {
      await getAuthBackend().signOut({
        global: true
      });
    } catch (error) {
      console.error("Sign out error:", error);
    } finally {
      Cookies.set("x-org-id", "", {
        path: "/",
        maxAge: 0
      });
      Cookies.set("x-team-id", "", {
        path: "/",
        maxAge: 0
      });
      // Trimble's logout() calls window.location.replace(end_session_endpoint) before
      // resolving. Calling assign here in the same JS tick would override that navigation,
      // preventing Trimble from ever reaching its session termination endpoint.
      if (authBackendId !== "trimble") {
        window.location.assign("/login");
      }
    }
  }, [authBackendId]);
  return {
    handleSignOut,
    isLoggingOut
  };
}